
export class Team  {
    _id: string;
    TeamName: string;
    Users: string[];
    OrganizationName: string;
}
